<template>
  <div class="mw-split-container mw-bar-data">
    <split-pane :defaultSize="150" split="vertical">
      <template slot="paneL">

      <mw-dialog ref="leadDialog" title="导出系统登录日志excel" size="mini_mini" :footerButton="leadButton">
       <div class="mw-dialog_body inner-toolbar__body" style="margin-top:20px;">
          <el-form label-width="100px">
            <el-col :span="24">
              <el-form-item label="开始时间">
                <template>
                  <el-date-picker
                    v-model="startDate"
                    type="datetime"
                    placeholder="选择时间"
                    :picker-options="pickerBeginDateBefore">
                  </el-date-picker>
                </template>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="结束时间">
                <template>
                    <el-date-picker
                    v-model="finishDate"
                    type="datetime"
                    placeholder="选择时间"
                    :picker-options="pickerBeginDateAfter">
                  </el-date-picker>
                </template>
              </el-form-item>
            </el-col>

          </el-form>
       </div>
      </mw-dialog>

       <mw-dialog ref="editDialog" title="查看信息" width="754px">

        <div class="mw-toolbar">
          <el-button  type="primary" @click="closeDialog('editDialog')"><i class="fa fa-mail-reply "></i> 关闭</el-button>
        </div>
       <div class="mw-toolbar__body inner-toolbar__body">
          <el-form label-width="130px">
            <el-col :span="24">
              <el-form-item label="用户名 :">
                <template>
                  <el-input style="width:96%" v-model="form.loginId" readonly></el-input>
                </template>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="名称 :">
                <template>
                  <el-input style="width:96%" v-model="form.userName" readonly></el-input>
                </template>
              </el-form-item>
            </el-col>

             <el-col :span="24">
              <el-form-item label="浏览器信息 :">
                <template>
                    <el-input style="width:96%" v-model="form.userAgent" readonly></el-input>
                </template>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="登录时间 :">
                <template>
                    <el-input readonly v-model="form.createTime"></el-input>
                </template>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="服务器地址 :">
                <template>
                    <el-input v-model="form.serverName" readonly></el-input>
                </template>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="服务器端口 :">
                <template>
                    <el-input v-model="form.serverPort" readonly></el-input>
                </template>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="客户端IP :">
                <template>
                    <el-input v-model="form.clientIP" readonly></el-input>
                </template>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="网卡地址 :">
                <template>
                    <el-input readonly></el-input>
                </template>
              </el-form-item>
            </el-col>

          </el-form>
       </div>
      </mw-dialog>

        <div class="mw-split-left">

          <div class="mw-toolbar__body">
            <div class="mw-toolbar">
              <el-button @click="expand"><i class="fa fa-angle-double-down"  v-if="!btnNotShowIcon"></i>展开</el-button>
              <el-button @click="closed"><i class="fa fa-angle-double-up"  v-if="!btnNotShowIcon"></i>折叠</el-button>
            </div>

            <div class="mw-toolbar__body">
              <mw-tree :url="treeUrl" :async="false" :multiple="false"  :selectFirst="true"
                       :expandedFirst="true"   @changed="loadTableTree" ref="logTree">
              </mw-tree>
            </div>
          </div>

        </div>
      </template>
      <template slot="paneR">
        <div class="mw-split-right" >
           <toolbar-table :layout="layout" :autoLoad="false"  ref="dataTable"></toolbar-table>
        </div>
      </template>
    </split-pane>

  </div>
</template>
<script>
export default {
  components: {

  },
  props: {
    params: {
      type: Object
    }
  },

  data() {
    let me = this;
    return {
      layout: [],
      headers: {},
      btnNotShowIcon:(window.$Env && $Env.btnNotShowIcon),
      treeUrl: this.mwUrl("/api/business/listAccessTree"),
      selectNode: "",
      finishDate: '',
      startDate: '',

      leadButton: [
        {
          label: "取消",
          type: "default",
          func: this.closeLeadDialog
        },
        {
          label: "确定",
          func: this.leadSure
        }
      ],

      form:{

      },

      pickerBeginDateBefore:{
          disabledDate(time) {
            if(me.finishDate != ''){
              return time.getTime() > me.finishDate
            }
          }
        },
        pickerBeginDateAfter:{
          disabledDate(time) {
            return time.getTime() < me.startDate
          }
        },
    };
  },

  mounted() {
    let me = this;
    me.layout = [
      [
        {
          span: 0,
          type: "menu",
          label: "响应日志",
          api: "business.listAccessLog",
          singleSelect: true,
          columns: [
            { prop: "requestURI", label: "请求地址",tooltip:true},
            { prop: "userName",label: "操作用户",tooltip: true,width:'80'},
            { prop: "createTime",label: "操作时间",tooltip: true,width:'160'},
            { prop: "accessType", label: "响应方式",tooltip:true,width:'80'},
            { prop: "clientIP", label: "客户端IP",tooltip:true,width:'100'},
            { prop: "userAgent",label: "浏览器类型",tooltip:true,width:'120',formatter:me.userAgentFormatter},
            { prop: "duration", label: "响应时长(毫秒)",sortable:true,tooltip:true,width:'130'},
          ]
        },
        {
          span: 10,
          type: "button",
          items: [
            {
              label: "导出",
              icon: me.btnNotShowIcon ? '' : "fa fa-plus-square",
              func: me.lead
            }
          ]
        },
        {
          span: 6,
          type: "searchText",
          name: "userName",
          tip:"操作用户或请求地址",
          offset: 8
        }
      ]
    ];
  },

  methods: {
    expand() {
      this.mwRef('logTree').openAll();
    },
    closed() {
      this.mwRef('logTree').closeAll();
    },
    loadTableTree(data) {
      this.selectNode = data.id;
      this.mwRef("dataTable").refreshTableDefaultParams({
        id: data.id
      });
    },

    userAgentFormatter(data,c,userAgent){
      if (userAgent == null)return "";
        var start = userAgent.indexOf("(");
        userAgent = userAgent.substring(start, userAgent.length);
        let os = "Windows";
        let bit = "32位";
        let brower = "";
        if (userAgent.indexOf("Windows NT 5.0") != -1) {
            os = "Win2000";
        } else if (userAgent.indexOf("Windows NT 5.1") != -1 || userAgent.indexOf("Windows XP") != -1) {
            os = "WinXP";
        } else if (userAgent.indexOf("Windows NT 5.2") != -1) {
            os = "Win2003";
        } else if (userAgent.indexOf("Windows NT 6.0") != -1) {
            os = "Win2008";
        } else if (userAgent.indexOf("Windows NT 6.1") != -1) {
            os = "Win7";
        } else if (userAgent.indexOf("Windows NT 6.2") != -1) {
            os = "Win8";
            if (userAgent.indexOf("ARM;") != -1) {
                os = "WinRT";
            }
        } else if (userAgent.indexOf("Windows NT 6") != -1) {
            os = "WinVista";
        } else if (userAgent.indexOf("Linux") != -1) {
            os = "Linux";
        } else if (userAgent.indexOf("Mac") != -1) {
            os = "Mac";
        }
        if (userAgent.indexOf("WOW64") != -1 || userAgent.indexOf("_64") != -1 || userAgent.indexOf("X64") != -1 || userAgent.indexOf("x64") != -1) {
            bit = "64位";
        }

        if (userAgent.indexOf("MSIE") != -1) {
            brower = "IE";
            var start = userAgent.indexOf("MSIE");
            var end = userAgent.indexOf(";", start);
            brower = brower + userAgent.substring(start + 5, end);
        } else if (userAgent.indexOf("rv:") != -1 && userAgent.indexOf("Firefox") == -1) {
            brower = "IE";
            var start = userAgent.indexOf("rv:");
            var end = userAgent.indexOf(")", start);
            brower = brower + userAgent.substring(start + 3, end);
        } else if (userAgent.indexOf("Firefox") != -1) {
            brower = "Firefox";
            var start = userAgent.indexOf("Firefox/");
            brower = brower + userAgent.substring(start + "Firefox".length + 1, userAgent.length);
        } else if (userAgent.indexOf("Chrome") != -1) {
            brower = "Chrome";
            var start = userAgent.indexOf("Chrome/");
            var end = userAgent.indexOf(".", start);
            end = userAgent.indexOf(".", end + 1);
            brower = brower + userAgent.substring(start + "Chrome".length + 1, end);
        } else if (userAgent.indexOf("Safari") != -1) {

            brower = "Safari";
            var start = userAgent.indexOf("Version/");
            var end = userAgent.indexOf(" ", start);
            brower = brower + userAgent.substring(start + "Version".length + 1, end);
        }

       return brower
    },


    lead() {
      this.mwRef("leadDialog").show();
    },

    closeLeadDialog(){
       this.mwRef("leadDialog").hide();
    },

    closeEditDialog(){
      this.mwRef('editDialog').hide();
    },

    edit(row,index){
         this.mwApi.business.getAccessLog(row.id).then(res =>{
             this.mwRef('editDialog').show();
             this.form = res.result;
         })
    },
    closeDialog(a){
      this.mwRef(a).hide()
    },
    leadSure(){
      var me=this;
      if(!me.startDate && !me.finishDate){
        me.mwMsg("warning", '请选择开始时间或结束时间!');
        return;
      }
      var params={};
      if(me.startDate)
        params.startDate=new moment(me.startDate).format("YYYY-MM-DD HH:mm:ss");
      if(me.finishDate)
        params.finishDate=new moment(me.finishDate).format("YYYY-MM-DD HH:mm:ss");
      this.mwApi.business.expAccessLog(params);
      this.closeLeadDialog();
    }
  },
  watch: {}
};
</script>
<style scoped>
.el-input {
  width: calc(100% - 5px);
}
.el-tree-node__content .el-checkbox {
  display: none;
}

</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/log/accessLog.vue